import i18n from '@/i18n';
import validationSecteur from '@/services/commun/secteur/validationSecteur';
import translate from './champsPatrimoineTranslator';

function GetTypePatrimoineTraduit(typePatrimoine) {
  switch (typePatrimoine) {
    case 'face':
      return i18n.t('patrimoine.error.face');
    case 'materiel':
      return i18n.t('patrimoine.error.materiel');
    case 'facility':
      return i18n.t('patrimoine.error.dispositif');
    case 'site':
      return i18n.t('patrimoine.error.emplacement');
    default:
      return typePatrimoine;
  }
}

export default function validationPatrimoine(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  validationSecteur(response, messages);
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORBIDDEN_TO_UPDATE_FACE_ARCHIVE') === 0) {
      messages.push({ message: 'detailFace.messages.error.forbiddenUpdateFaceArchive' });
    }
    if (message.indexOf('CODE_REQUIRED_IF_MASK_COMPANY_EMPTY') === 0) {
      let typePatrimoine = message.split('|')[0].split('@')[1];
      typePatrimoine = GetTypePatrimoineTraduit(typePatrimoine);
      messages.push({
        message: 'patrimoine.error.codeRequiredIfNoMask',
        parametres: {
          typePatrimoine: typePatrimoine,
        },
      });
    }
    if (message.indexOf('FORBIDDEN_TO_CREATE_MATERIEL_IF_DISPOSITIF_ARCHIVE') === 0) {
      messages.push({
        message: 'patrimoine.error.createMateriel',
      });
    }
    if (message.indexOf('CREATE_DISPOSITIF_FORBIDDEN_IF_EMPLACEMENT_IS_ARCHIVE') === 0) {
      messages.push({
        message: 'patrimoine.error.createDispositif',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_CREATE_FACE_IF_MATERIEL_ARCHIVE') === 0) {
      messages.push({
        message: 'patrimoine.error.createFace',
      });
    }
    if (message.indexOf('EMPLACEMENT_CLIENT_MUST_BE_NULL') === 0) {
      messages.push({
        message: 'patrimoine.error.clientMustbeNull',
      });
    }
    if (message.indexOf('EMPLACEMENT_CUSTOMER_IS_REQUIRED') === 0) {
      messages.push({
        message: 'patrimoine.error.clientObligatoire',
      });
    }
    if (message.indexOf('CODE_GENERATION_ELEMENT_REQUIRED') === 0) {
      const propriete = translate(i18n,
        message.split('|')[0].split('@')[1]
          .replace('{', '')
          .replace('}', ''),
      );
      messages.push({
        message: 'patrimoine.error.codeGenerationElementRequired',
        parametres: {
          propriete: propriete,
        },
      });
    }

    if (message.indexOf('PATRIMOINE_CANT_SWITCH_NUMERIQUE') === 0) {
      messages.push({
        message: 'patrimoine.error.cantSwitchNumerique',
      });
    }
    if (message.indexOf('PATRIMOINE_ETAT_HISTORIQUE_CANNOT_BE_A_SAME') === 0) {
      messages.push({
        message: 'patrimoine.error.etatCannotBeASame',
      });
    }
  });
}
